export const COMMUNICATIONS_TENANT_IDS = ['67153ac5-c67b-4811-9bff-dadc48dc57bb', '52f83c57-bff7-4b8b-8248-bc6de5570c14'];

export const isCommunicationsTenant = (tenantId?: string) => COMMUNICATIONS_TENANT_IDS.includes(tenantId ?? '');
